// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";
import calendarIcon from "assets/svg/data.svg";
import locationIcon from "assets/svg/locationGrey.svg";

// STYLES
import {
    EventCardContainer,
    ImgCard,
    TitleText,
    Subtitle,
    WrapperButton,
    DsuWrapper,
    DsuImg,
    ImgSubtitle, ImgWrap,
} from "./EventCardStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// MISC

import { IProps } from "./EventCardModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import { uploadBaseUrl } from "services/base";
import { appRoutes } from "config/AppRoutesConfig";
import formatDate from "utils/formatDate";

const EventCard = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const navigate = useNavigate();

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  const handleClick = (id) => {
    navigate(`${appRoutes.eventDetails}${id}`);
  };

  return (
    <EventCardContainer onClick={() => handleClick(props?.id)}>

          <ImgCard
            src={
              props?.attributes?.photo?.data?.attributes?.url?.trim()
                ? `${uploadBaseUrl}${props?.attributes?.photo?.data?.attributes?.url}`
                : CoverPlaceholder
            }
          />

      <DsuWrapper>
        <DsuImg
          src={
            props?.attributes?.partener_logo?.data?.attributes?.url?.trim()
              ? `${uploadBaseUrl}${props?.attributes?.partener_logo?.data?.attributes?.url}`
              : CoverPlaceholder
          }
        />
        <CustomText
          type={TextType.H4}
          text={props?.attributes?.partener}
          color={COLORS.MetalicSilver}
        />
      </DsuWrapper>
      <TitleText>
        <CustomText type={TextType.H3} text={props?.attributes?.title} />
      </TitleText>
      <Subtitle>
        <ImgSubtitle src={calendarIcon} />
        <CustomText
          type={TextType.P2}
          text={formatDate(
            props?.attributes?.start_date,
            props?.attributes?.end_date,
            "ro"
          )}
          color={COLORS.MetalicSilver}
        />
      </Subtitle>
      <Subtitle>
        <ImgSubtitle src={locationIcon} />
        <CustomText
          type={TextType.P2}
          text={`${props?.attributes?.address || ""}, ${props?.attributes?.city || ""}`}
          color={COLORS.MetalicSilver}
        />
      </Subtitle>

      <WrapperButton>
        <ButtonAtom
          type={ButtonType.RedButton}
          text={t("view.newsAndMedia.officialAnnouncements.openButton")}
          hasArrow={true}
          onClick={() => handleClick(props?.id)}
        />
      </WrapperButton>
    </EventCardContainer>
  );
};

export default EventCard;
